import React from "react";
import { cn } from "@/lib/utils";

const chainLinks = [
  { key: "helpfulFrame", label: "Frame", color: "bg-chain-frame" },
  { key: "clearValues", label: "Values", color: "bg-chain-values" },
  { key: "creativeAlternatives", label: "Alt", color: "bg-chain-alternatives" },
  { key: "usefulInformation", label: "Info", color: "bg-chain-information" },
  { key: "soundReasoning", label: "Reason", color: "bg-chain-reasoning" },
  { key: "commitmentToFollow", label: "Commit", color: "bg-chain-commitment" },
];

const DecisionChainMini = ({ ratings }) => {
  const averageRating = Object.values(ratings).reduce((a, b) => a + b, 0) / 6;
  const weakestLink = Math.min(...Object.values(ratings));

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-muted-foreground">Decision Strength</span>
        <span className={cn(
          "text-xs font-semibold",
          weakestLink >= 70 ? "text-success" : weakestLink >= 40 ? "text-warning" : "text-destructive"
        )}>
          {Math.round(weakestLink)}%
        </span>
      </div>
      
      {/* Mini Chain Visualization */}
      <div className="flex gap-1">
        {chainLinks.map((link) => {
          const value = ratings[link.key] || 0;
          return (
            <div key={link.key} className="flex-1 flex flex-col items-center gap-1">
              <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
                <div 
                  className={cn("h-full rounded-full transition-all duration-500", link.color)}
                  style={{ width: `${value}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      
      {/* Legend */}
      <div className="flex flex-wrap gap-x-2 gap-y-1">
        {chainLinks.map((link) => (
          <div key={link.key} className="flex items-center gap-1">
            <div className={cn("w-2 h-2 rounded-full", link.color)} />
            <span className="text-[10px] text-muted-foreground">{link.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DecisionChainMini;
